<template>
    <div>
        <ul class="nav nav-pills">
            <li v-for="(group, i) in groups" :key="i" class="nav-item">
                <router-link :to="`/auth/dashboard/grid/${group.slug}`" class="nav-link" style="font-size: 13px" exact>
                    {{ group.name[locale] }}
                </router-link>
            </li>
        </ul>
        <div class="tab-content">
            <router-view name="gridview" :additions="additions"/>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import Vue from 'vue';
import DashboardService from '@services/dashboard.service';
import AdditionService from '@services/addition.service';

export default {
    data() {
        return {
            groups: [],
            additions: []
        };
    },
    computed: {
        ...mapGetters(['locale', 'langs'])
    },
    methods: {
        getGroups() {
            DashboardService.groups().then(res => {
                this.groups = res;
                this.$router.push({path:`/auth/dashboard/grid/${res[0].slug}`});
            });
        },
        getAdditions() {
            AdditionService.additions().then(res => this.additions = res);
        },
    },
    created() {
        this.getGroups();
        this.getAdditions();
    }
};
</script>
